import React from 'react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './ui/CtaButton';
import { modules, CHECKOUT_URL } from '../data/content';
export function ModulesSection() {
  return <section aria-labelledby="modulos" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-14 text-center" data-id="element-129" data-mp="1iw339c80w74c">
      <Reveal data-id="element-130" data-mp="1dunhtj1xnylf">
        <SectionHeading id="modulos" eyebrow="¿Qué incluye?" title="6 Módulos digitales" data-id="element-131" data-mp="2bk8soca0ukai" />
      </Reveal>

      <ol className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-132" data-mp="26mgxn9e2yi23">
        {modules.map((mod, i) => <Reveal key={mod.title} as="li" delay={i * 0.03} className="flex h-full flex-col items-center rounded-2xl border border-line bg-surface p-7 text-center" data-id="element-133" data-mp="21kht3w6ltf3k" data-mpi={i}>
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-night font-display text-lg font-bold text-gold-light" data-id="element-134" data-mp="q4ta1fwh1081">
              {i + 1}
            </span>
            <h3 className="mt-4 font-display text-xl font-bold uppercase leading-tight text-ink" data-id="element-135" data-mp="1iw0bccre46fg">
              {mod.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-ink-muted" data-id="element-136" data-mp="18xb37bpaq0ce">
              {mod.desc}
            </p>
            {mod.extra && <p className="mt-auto pt-5 text-sm font-bold uppercase tracking-wide text-gold" data-id="element-137" data-mp="1duulqnt10za5">
                {mod.extra}
              </p>}
          </Reveal>)}
      </ol>

      <Reveal delay={0.1} className="mt-10 flex justify-center" data-id="element-138" data-mp="14w94qx37dsbh">
        <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-139" data-mp="q736pcg3q856">
          Quiero acceder ahora
        </CtaButton>
      </Reveal>
    </section>;
}